import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';

@Component({
    selector: 'app-selected-wrapper',
    templateUrl: './selected-wrapper.component.html',
    styleUrls: ['./selected-wrapper.component.scss'],
    standalone: false
})
export class SelectedWrapperComponent implements OnInit, OnChanges {
  @Input() selectedApplicants: ChipItem[] = []; //applicants coming on UI as chips
  @Output() removeItem = new EventEmitter(); // to remove applicants from list
  showMessage: boolean = false; //bottom message near button container
  cannotSelectMessage: string = ''; //message near chip container
  notValidForNextStageMessage: string = ''; // message for testgiven tab shorlisted selected modal
  tertiaryMessage: string = ''; // message for testgiven tab shorlisted selected modal

  ngOnInit(): void {}

  ngOnChanges(): void {
    const cannotSelect = this.selectedApplicants.filter(
      (item: ChipItem) => item.cannotSelect
    );
    const isNotEligibleForNextStage = this.selectedApplicants.filter(
      (item: ChipItem) => item.notAppearedForTest
    );
    let failedApplicants: ChipItem[] = [];
    if (
      this.selectedApplicants.length &&
      Object.keys(this.selectedApplicants[0]).includes('interviewResult')
    ) {
      failedApplicants = this.selectedApplicants.filter(
        (item: ChipItem) => item.interviewResult !== 'SR001'
      );
    }

    if (cannotSelect.length !== 0) {
      // cannotSelect is for those applicants who have moved to the next stage and should not be selected again to move.
      let message = cannotSelect.map((item: any) => item.text).join(', ');
      this.cannotSelectMessage =
        message +
        `${
          cannotSelect.length === 1 ? ' is' : ' are'
        } already moved to next stage. Please uncheck the applicant(s) to proceed.`;
    } else {
      this.cannotSelectMessage = '';
    }
    // If all the applicants are ok to move on to the next stage, then check for failed applicants.
    if (failedApplicants.length !== 0) {
      // Failed applicants should be removed.
      let message = failedApplicants.map((item: any) => item.text).join(', ');
      this.notValidForNextStageMessage =
        message +
        `${
          failedApplicants.length === 1 ? ' is' : ' are'
        } not eligible for next stage. Please update the status or kindly check the interview result to proceed.`;
    } else {
      //if both conditions are false, i.e., the applicant has passed and has not moved yet to the next stage, then show no message.
      this.notValidForNextStageMessage = '';
    }

    if (isNotEligibleForNextStage.length !== 0) {
      let message = isNotEligibleForNextStage
        .map((item: any) => item.text)
        .join(', ');
      this.tertiaryMessage =
        message +
        `${
          isNotEligibleForNextStage.length === 1 ? ' is' : ' are'
        } not eligible for next stage. Please update the status or kindly check the result to proceed.`;
    } else {
      this.tertiaryMessage = '';
    }
  }

  fnRemoveItem(id: number) {
    if (this.selectedApplicants.length <= 1) {
      this.showMessage = true;

      // Hide the message after 5 seconds
      setTimeout(() => {
        this.showMessage = false;
      }, 5000);

      return;
    }
    this.removeItem.emit(id);
  }
}

export interface ChipItem {
  id?: number;
  text: string;
  cannotSelect?: boolean;
  notAppearedForTest?: boolean;
  interviewResult?: string | null;
}
